import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { Star, ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const ReviewsSection = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchReviews();
  }, []);

  const fetchReviews = async () => {
    try {
      const data = await api.getActiveReviews();
      setReviews(data.reviews || []);
    } catch (err) {
      console.error('Error fetching reviews:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (reviews.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Ce que disent nos clients
          </h2>
          <p className="text-lg text-gray-600">
            Découvrez les avis de nos clients satisfaits
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.slice(0, 6).map((review) => (
            <Card key={review.id} className="hover:shadow-lg transition-shadow">
              <CardContent className="p-6">
                <div className="flex items-center mb-4">
                  {review.image_url && (
                    <img
                      src={`${process.env.REACT_APP_BACKEND_URL}${review.image_url}`}
                      alt={review.author_name}
                      className="h-12 w-12 rounded-full object-cover mr-3"
                    />
                  )}
                  <div className="flex-1">
                    <h3 className="font-semibold text-gray-900">{review.author_name}</h3>
                    <div className="flex mt-1">
                      {[...Array(5)].map((_, i) => (
                        <Star
                          key={i}
                          className={`h-4 w-4 ${
                            i < review.rating
                              ? 'fill-yellow-400 text-yellow-400'
                              : 'text-gray-300'
                          }`}
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed mb-3">
                  "{review.comment}"
                </p>
                {review.original_link && (
                  <a
                    href={review.original_link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center text-sm text-green-600 hover:text-green-700"
                  >
                    Voir la source
                    <ExternalLink className="h-3 w-3 ml-1" />
                  </a>
                )}
                {review.date && (
                  <p className="text-xs text-gray-400 mt-2">
                    {new Date(review.date).toLocaleDateString('fr-CH')}
                  </p>
                )}
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
